import React from 'react';
import Aux from '../../../../hoc/ReactAux/ReactAux';

const getStyle = (disabled, expired = false) => {
  if (disabled && !expired) {
    return {
      color: 'gray',
      cursor: 'not-allowed',
    };
  } else if (expired) {
    return {
      color: 'red',
    };
  }
  return {
    cursor: 'pointer',
  };
};

const paymentOptions = props => {
  let country = localStorage.getItem('country');

  let options = null;
  if (props.total === 0 && props.subsidy > 0 && !props.onlyCreditCard) {
    options = (
      <div className="order-voucher payment-options">
        <h4 className="fl" tabIndex={0}>
          Payment Options
        </h4>
        <div className="radio-payment">
          <input
            disabled={props.disabled}
            onChange={event => props.selectPaymentMethod(event, 'onVoucher')}
            type="radio"
            name="paymentOption"
            id="onVoucher"
            checked={props.payTypeSelected === 'A'}
          />
          <label style={getStyle(props.disabled)} htmlFor="onVoucher">
            <b>Pay with Voucher</b>
          </label>
        </div>
      </div>
    );
  } else if (
    !!props.business &&
    props.business.acceptOnAccount === 'Y' &&
    !props.onlyCreditCard
  ) {
    options = (
      <div className="order-voucher payment-options">
        <h4 className="fl">Payment Options</h4>
        <div className="radio-payment">
          <Aux key={0}>
            <input
              disabled={props.disabled}
              onChange={event => props.selectPaymentMethod(event, 'onAccount')}
              type="radio"
              name="paymentOption"
              id="onAccount"
              checked={props.payTypeSelected === 'A'}
            />
            <label style={getStyle(props.disabled)} htmlFor="onAccount">
              <b>On Account</b>
            </label>
          </Aux>
        </div>
      </div>
    );
  } else {
    options = (
      <div className="order-voucher payment-options">
        <h4 className="fl">Payment Options</h4>
        <div className="radio-payment">
          {props.cards.map((card, index) => (
            <Aux key={index}>
              <input
                disabled={props.disabled}
                onChange={event =>
                  props.selectPaymentMethod(card.cardId, 'onCreditCard')
                }
                type="radio"
                name="paymentOption"
                id={card.cardId}
                checked={
                  props.payTypeSelected === 'C' &&
                  props.cardSelected &&
                  props.cardSelected.cardId === card.cardId
                }
              />
              <label
                style={getStyle(props.disabled, card.expired)}
                htmlFor={card.cardId}
              >
                <b>{card.brandName}</b> - ending {card.lastFour}
                {card.expired ? '(card expired)' : null}
              </label>
            </Aux>
          ))}
          {country === 'Belgium' && (
            <Aux key={13}>
              <input
                disabled={props.disabled}
                onChange={event =>
                  props.selectPaymentMethod(event, 'bancontact')
                }
                type="radio"
                name="paymentOption"
                id="bancontact"
                checked={props.payTypeSelected === 'B'}
              />
              <label style={getStyle(props.disabled)} htmlFor="bancontact">
                <b>Bancontact</b>
              </label>
            </Aux>
          )}
          {country === 'Netherlands' && (
            <Aux key={12}>
              <input
                disabled={props.disabled}
                onChange={event => props.selectPaymentMethod(event, 'ideal')}
                type="radio"
                name="paymentOption"
                id="ideal"
                checked={props.payTypeSelected === 'I'}
              />
              <label style={getStyle(props.disabled)} htmlFor="ideal">
                <b>Ideal</b>
              </label>
            </Aux>
          )}
          <Aux>
            <input
              disabled={props.disabled}
              onChange={event =>
                props.selectPaymentMethod('payWithAnotherCard', 'onCreditCard')
              }
              type="radio"
              name="paymentOption"
              id="payWithAnotherCard"
              checked={props.payTypeSelected === 'C' && !props.cardSelected}
            />
            <label
              style={getStyle(props.disabled)}
              htmlFor="payWithAnotherCard"
            >
              <b>Pay with another card </b>
            </label>
          </Aux>
        </div>
      </div>
    );
  }

  return options;
};

export default paymentOptions;



// WEBPACK FOOTER //
// ./src/containers/Menu/Cart/PaymentOptions/index.js